import { ReactSVG } from "react-svg";
import "./InstallmentPayment.scss";
import React, { FC } from "react";
import { formatInstallmentAmountUAH, getDimensionValues } from "./utils";
import { installmentIcons } from "./const";

export type InstallmentPaymentProps = {
    installmentCount: number;
    fullAmount: number;
    size?: "medium" | "large";
};

export const InstallmentPayment: FC<InstallmentPaymentProps> = ({
    installmentCount,
    fullAmount,
    size = "large",
}) => {
    const iconSize = getDimensionValues(size);

    return <div className={`installment-payment installment-payment--${size}`}>
        <div className={"installment-payment__icons"}>
            {Object.entries(installmentIcons).map(([key, icon]) => {
                return <div id={key} key={key} className={"installment-payment__icon-wrapper"}>
                    <ReactSVG
                        className={"installment-payment__icon"}
                        style={{ height: iconSize }}
                        src={icon}
                        beforeInjection={(svg) => {
                            svg.setAttribute("width", iconSize.toString());
                            svg.setAttribute("height", iconSize.toString());
                        }}
                    />
                    <span
                        className={"installment-payment__badge"}
                    >
                    {installmentCount}
                </span>
                </div>
            })}
        </div>
        <div className={`installment-payment__amount installment-payment__amount--${size}`}>
            {formatInstallmentAmountUAH(fullAmount, installmentCount)}
        </div>
    </div>
}